const normalize = (value) => String(value || "").trim().toLowerCase()

const mountIntegrationGallerySearch = () => {
  document.querySelectorAll("[data-integration-gallery]").forEach((container) => {
    if (container.dataset.gallerySearchMounted === "true") return
    container.dataset.gallerySearchMounted = "true"

    const input = container.querySelector("[data-integration-gallery-search-input]")
    const emptyState = container.querySelector("[data-integration-gallery-search-empty]")
    const cards = Array.from(container.querySelectorAll("[data-integration-gallery-card]"))

    if (!input) return

    const filter = () => {
      const query = normalize(input.value)
      let visibleCount = 0

      cards.forEach((card) => {
        const searchText = normalize(card.dataset.integrationGallerySearchText)
        const matches = query.length === 0 || searchText.includes(query)
        card.hidden = !matches
        if (matches) visibleCount += 1
      })

      if (emptyState) emptyState.hidden = visibleCount > 0
    }

    input.addEventListener("input", filter)
    filter()
  })
}

export { mountIntegrationGallerySearch }
